import React, { useContext } from "react";
import DownloadIcon from "../../../components/VectorIcons/DownloadIcon";
import AppContext from "../../../context/appContext";
import CheckBox from "../../../components/CheckBox/CheckBox";
import FileView from "../../../components/VectorIcons/FileView";
import useDownloadAttachment from "../../../hooks/useDownloadAttachment";
import AttachmentsContext from "../../../context/attachmentsContext";
import { VIEWABLE_FILE_TYPES } from "../../../shared/constants/store";
import CustomTooltip from "../../../components/CustomTooltip/CustomTooltip";
import { getFileExtensionFromFileName } from "../../../shared/utils/getFileExtensionFromFileName";

const getReleaseStatus = (file) => {
  return file.release ?? file.releaseManagement?.channel ?? false;
};

const getReleaseDate = (file) => {
  return (
    file.releaseManagement?.history?.slice(-1)?.[0]?.actionDate ??
    file.releaseDate
  );
};

const ListAttachments = (props) => {
  const {
    index,
    file,
    handleChangeFiles,
    title,
    parentIndex,
    type,
    contentId,
    renameEpisodeLabel,
  } = props;

  const appContext = useContext(AppContext);
  const { downloadAttachment } = useDownloadAttachment();
  const { setFileToView } = useContext(AttachmentsContext);

  const isReleased = getReleaseStatus(file);

  const typeName = file.attachmentType?.name ?? file.type?.name ?? "-";
  const isAddenda = typeName === "Adendo";

  const displayTypeName =
    renameEpisodeLabel && typeName === "Capítulo/Episódio"
      ? "Episódio"
      : typeName;

  const releaseDate = getReleaseDate(file);

  const canDownload = isReleased && !!file.fileId;

  const canView = isReleased && !!file.fileId;

  const fileToVisualize = {
    fileData: file,
    contentId,
    origin: "visualizador-textos-liberados",
    mode: 1,
    autoSave: false,
  };

  const fileToDownload = {
    fileData: file,
    contentId,
    origin: "textos-liberados",
    mode: 0,
  };

  const fileExtension = getFileExtensionFromFileName(file?.fileName);

  const canViewFile =
    VIEWABLE_FILE_TYPES.includes(fileExtension) &&
    file?.fileName !== null &&
    canView;

  return (
    <div className="attachmentItem" key={index}>
      <ul
        className={
          type === "channels" ? "releasedVersionItem" : "mainVersionItem"
        }
      >
        <li className="type">
          {!!isReleased ? (
            <div>
              <CheckBox
                isActive={file.isActive}
                event={() =>
                  handleChangeFiles(
                    file.fileId,
                    file.fileName,
                    title,
                    file,
                    true,
                    parentIndex,
                    index
                  )
                }
              />
            </div>
          ) : (
            <div style={{ width: 28 }} />
          )}

          <span className="typeName">
            {isAddenda ? "Adendo" : displayTypeName || "-"}

            {["Capítulo/Episódio", "Episódio"].includes(typeName) &&
            file.chapterNumber
              ? ` ${file.chapterNumber}`
              : ""}
          </span>

          {(typeName === "Capítulo/Episódio" || typeName === "Episódio") &&
            type !== "channels" && (
              <span className="blockNumber">
                {" "}
                Bloco {file.blockNumber > 0 && file.blockNumber}
              </span>
            )}
        </li>

        {!isAddenda && (
          <li className={`version`}>
            <span className="versionNumber">
              {file.version ? `${file.version}ª` : "-"}
            </span>
            <span className="versionText">versão</span>
          </li>
        )}

        <li className="fileComment">
          <p className="fileNameAttachment">
            <strong>{file?.fileName}</strong>
          </p>
          {!file.comment && type === "channels" ? "-" : file.comment}
        </li>

        <li className="fileComment">
          {!!file.relatedNumbers?.length && (
            <span className="relatedChapters">
              {`${file.relatedNumbers.join(", ")}`}
            </span>
          )}
        </li>

        <li className="receivedAt">
          {releaseDate &&
            appContext.formatDate(appContext.convertDatePtBr(releaseDate))}
        </li>

        <li className="download">
          {canDownload ? (
            <>
              <div
                className="actionItem"
                onClick={
                  canViewFile ? () => setFileToView(fileToVisualize) : undefined
                }
                style={{
                  cursor: canViewFile ? "pointer" : "default",
                  opacity: canViewFile ? 1 : 0.4,
                }}
              >
                {canViewFile ? (
                  <FileView color="#0098CD" />
                ) : (
                  <CustomTooltip
                    tipLabel={<FileView color="#CCC" />}
                    dataTip="Formato não suportado ou arquivo não liberado"
                    position="left"
                    theme="light"
                  />
                )}
              </div>

              <div
                className="actionItem"
                onClick={() => downloadAttachment(fileToDownload)}
              >
                <DownloadIcon />
              </div>
            </>
          ) : (
            <div className="download-placeholder" />
          )}
        </li>
      </ul>
    </div>
  );
};

export default ListAttachments;
